import "./OnOffSwitchComponent.scss";

import React, { useState } from "react";
import { CustomInput } from "reactstrap";
import { uuidv4 } from "../../utils/utils";
import { CustomInputProps } from "reactstrap/lib/CustomInput";

export function OnOffSwitchComponent({ title, ...props }: Partial<CustomInputProps>) {
    const [id] = useState(() => "id_" + uuidv4());

    return (
        <div className="OnOffSwitch" title={title}>
            <CustomInput type="switch" id={id} {...props} />
        </div>
    );
}
